export const projectsData = [
  {
    id: 1,
    name: "AttireX-Fashion",
    imgUrl:
      "https://res.cloudinary.com/dptfwcnro/image/upload/v1686821005/Portfolio/qly7wxdepnye5qsb62vm.png",
    info:
      "A Fashion e-commerce website that aims to provide a seamless and enjoyable shopping experience.",
    github: "https://github.com/chhakuli123/ATTIREX-FASHION",
    live: "https://attirex-fashion.netlify.app/",
  },
  {
    id: 2,
    name: "SocialBuzz",
    imgUrl:
      "https://res.cloudinary.com/dptfwcnro/image/upload/v1686821234/Portfolio/ndrpsnagw5eyzedjxzlt.png",
    info:
      "Social Buzz is a compact social media app designed for connecting and engaging with others.",
    github: "https://github.com/chhakuli123/SocialBuzz",
    live: "https://social-buzz-app.netlify.app/",
  },
  {
    id: 3,
    name: "WatchTrove",
    imgUrl:
      "https://res.cloudinary.com/dptfwcnro/image/upload/v1687698479/Portfolio/xm6o3ugelgwilt7evdex.png",
    info:
      "Social Buzz is a compact social media app designed for connecting and engaging with others.",
    github: "https://github.com/chhakuli123/WatchTrove",
    live: "https://watch-trove.netlify.app/",
  },
];

export const blogsData = [
  {
    id: 1,
    headerUrl:
      "https://res.cloudinary.com/dptfwcnro/image/upload/v1686821701/Portfolio/xu9rdthmdaev4qnvaolf.avif",
    title: "♻️Event Loop♻️",
    date: "Sep 12, 2022",
    url: "https://chhakulizingare.hashnode.dev/javascript-event-loop",
  },
  {
    id: 2,
    headerUrl:
      "https://res.cloudinary.com/dptfwcnro/image/upload/v1686822078/Portfolio/v7itkgdss6jxjy3j7ay2.avif",
    title: "🪝useContext Hook🪝",
    date: "Oct 28, 2022",
    url: "https://chhakulizingare.hashnode.dev/usecontext-hook",
  },
  {
    id: 3,
    headerUrl:
      "https://res.cloudinary.com/dptfwcnro/image/upload/v1686822163/Portfolio/o2pwgmy83szpradin7v5.avif",
    title: "Hoisting in JavaScript",
    date: "Sep 4, 2022",
    url: "https://chhakulizingare.hashnode.dev/hoisting-in-javascript",
  },
];
